import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";
import { SearchTerm } from "@tSchaedlerYesco/Types/CustomAPIModels";

export interface SearchTermApiParameter extends SearchTerm, ApiParameter {
}

const apiUrl = "/api/v2/searchTerm/addSearchTerm";

export async function AddSearchTerm(parameter: SearchTermApiParameter): Promise<ServiceResult<void>> {
    try {
        const result = await post<SearchTermApiParameter, void>(apiUrl, parameter)
        return {
            successful: true,
            result
        }
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}